import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "vimeo-iframe__container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "vimeo-iframe__icon-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vimeo-iframe__icon" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "60",
      height: "65",
      viewBox: "0 0 60 65",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M56.6434 28.0552C60.1789 30.0308 60.1789 34.9698 56.6434 36.9454L8.91389 63.6163C5.37838 65.5919 0.958984 63.1224 0.958984 59.1712L0.958987 5.82943C0.958987 1.87819 5.37838 -0.591331 8.9139 1.38429L56.6434 28.0552Z",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_4 = {
  class: "vimeo-iframe__player",
  ref: "playerRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!$setup.isPlaying)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "vimeo-iframe__thumbnail-container",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.play && $setup.play(...args)))
              }, [
                ($props.videoThumbnailUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      alt: "",
                      class: "vimeo-iframe__thumbnail",
                      src: $props.videoThumbnailUrl
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                _hoisted_3
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, null, 512),
      ($setup.isPlaying)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.pause && $setup.pause(...args))),
            class: "vimeo-iframe__close"
          }, [
            _createVNode(_component_icon_close)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}